import theme from 'Lib/theme';

import { ProspectStatusValue, PROSPECT_STATUSES } from '~/types';

declare module '@mui/material/styles' {
	interface Palette {
		chips: {
			primary: string;
			secondary: string;
			success: string;
			info: string;
			warning: string;
			danger: string;
		};
	}
	interface PaletteOptions {
		chips?: {
			primary: string;
			secondary: string;
			success: string;
			info: string;
			warning: string;
			danger: string;
		};
	}
}

// TODO: remove this type once we have Trellis and use colors directly from the theme
type ChipVariant = 'filled' | 'outlined' | 'default' | 'info' | 'warning' | 'success' | 'error' | 'selectable' | 'danger';

export interface ProspectStatusConfig {
	label: string;
	variant: ChipVariant;
	iconConfig: {
		color: string;
		icon: string;
	};
}

export const PROSPECT_STATUS_LABELS: Record<ProspectStatusValue, string> = {
	[PROSPECT_STATUSES.PENDING]: 'New',
	[PROSPECT_STATUSES.INVITE_SENT]: 'Invitation Sent',
	[PROSPECT_STATUSES.APP_STARTED]: 'Application Started',
	[PROSPECT_STATUSES.APP_COMPLETED]: 'Application Submitted',
	[PROSPECT_STATUSES.ARCHIVED]: 'Archived'
} as const;

export const prospectStatusConfigMap: Record<ProspectStatusValue, ProspectStatusConfig> = {
	[PROSPECT_STATUSES.PENDING]: {
		label: PROSPECT_STATUS_LABELS[PROSPECT_STATUSES.PENDING],
		variant: 'warning',
		iconConfig: {
			color: theme.palette.chips.warning,
			icon: 'release_alert'
		}
	},
	[PROSPECT_STATUSES.INVITE_SENT]: {
		label: PROSPECT_STATUS_LABELS[PROSPECT_STATUSES.INVITE_SENT],
		variant: 'default',
		iconConfig: {
			color: theme.palette.chips.secondary,
			icon: 'send'
		}
	},
	[PROSPECT_STATUSES.APP_STARTED]: {
		label: PROSPECT_STATUS_LABELS[PROSPECT_STATUSES.APP_STARTED],
		variant: 'default',
		iconConfig: {
			color: theme.palette.chips.secondary,
			icon: 'insert_drive_file'
		}
	},
	[PROSPECT_STATUSES.APP_COMPLETED]: {
		label: PROSPECT_STATUS_LABELS[PROSPECT_STATUSES.APP_COMPLETED],
		variant: 'success',
		iconConfig: {
			color: theme.palette.chips.success,
			icon: 'check_circle'
		}
	},
	[PROSPECT_STATUSES.ARCHIVED]: {
		label: PROSPECT_STATUS_LABELS[PROSPECT_STATUSES.ARCHIVED],
		variant: 'default',
		iconConfig: {
			color: theme.palette.chips.secondary,
			icon: 'inventory_2'
		}
	}
} as const;

export interface ProspectStatusChipProps {
	status: ProspectStatusValue;
}
